<!-- src/components/Header.vue -->
<template>
    <header class="header__wrapper rlms-bg-white">
        <div class="rlms-container" :style="{
            maxWidth: ['LearnerAssessment', 'LearnerWorkpacketDetail'].includes($route.name) || $route.path.includes('/admin') ? '100%' : ''
        }">
            <div class="group__box">
                <!-- Logo -->
                <div class="logo__box">
                    <RouterLink to="/">
                        <img :src="logo" alt="EESA R APP" />
                    </RouterLink>
                </div>

                <!-- Navigation -->
                <div class="header__menu__box">
                    <nav class="navbar">
                        <ul>
                            <li :class="{ active: isActive('/') }">
                                <RouterLink to="/">Home</RouterLink>
                            </li>
                            <li :class="{ active: isActive('/pricing') }">
                                <RouterLink to="/pricing">Pricing</RouterLink>
                            </li>
                            <template v-if="authStore.user">
                                <li :class="{ active: isActive('/dashboard') }">
                                    <RouterLink to="/dashboard">Dashboard</RouterLink>
                                </li>
                                <li
                                    :class="{ active: isActive('/learners') || learnerRouteNames.includes($route.name) }">
                                    <RouterLink to="/learners">Learners</RouterLink>
                                </li>
                                <li
                                    :class="{ active: isActive('/organizations') || ($route.path.includes('/organizations') && !$route.path.includes('/admin/organizations')) && !learnerRouteNames.includes($route.name) }">
                                    <RouterLink to="/organizations">Organizations</RouterLink>
                                </li>
                                <li v-if="authStore?.role === 'admin'" :class="{ active: $route.path.includes('/admin') }">
                                    <RouterLink to="/admin/dashboard">
                                        <span class="rlms-fs-sm">Admin</span>
                                    </RouterLink>
                                </li>
                            </template>
                        </ul>
                    </nav>
                    <div class="header__btn__box header__btn__box_sm" style="margin-top: 30px;" v-if="!authStore.user">
                        <span class="signin__link">
                            <RouterLink to="/login">Sign In</RouterLink>
                        </span>
                        <div class="register__btn">
                            <RouterLink to="/register">Register</RouterLink>
                        </div>
                    </div>
                </div>

                <!-- Mobile Menu + Auth Buttons -->
                <div class="mobile__cover">
                    <div class="rlms-tooltip-wrapper"
                        style="background-color: #ffffff !important; --rlms-t-width:250px;--rlms-t-border-radius:10px;"
                        v-show="authStore?.user?.name">
                        <div class="rlms-tooltip-button" aria-expanded="true" ref="trigger">
                            <div class="rlms-profile-image-border-box">
                                <img :src="authStore?.user?.profilePicture" width="40px" style="border-radius: 50px;">
                                <p class="rlms-profile-name">{{ authStore?.user?.name }}</p>
                                <img :src="navBarSvg" width="24" height="24" class="rlms-profile-dd-icon" alt="">
                            </div>
                        </div>
                        <div class="rlms-tooltip-content" ref="tooltipContent">
                            <div class="rlms-profile-box">
                                <div class="rlms-profile-image-name-box">
                                    <div class="rlms-profile-image">
                                        <img :src="authStore?.user?.profilePicture" width="80px"
                                            style="border-radius: 50px;">
                                    </div>
                                    <div class="rlms-profile-name">
                                        <div class="rlms-fs-lg rlms-fw-500">{{ authStore?.user?.name }}</div>
                                    </div>
                                </div>
                                <ul>
                                    <li v-if="authStore?.role === 'admin'">
                                        <RouterLink to="/admin/dashboard">
                                            <span class="material-symbols-outlined">shield_person</span>
                                            <span class="rlms-fs-sm">Admin</span>
                                        </RouterLink>
                                    </li>
                                    <li>
                                        <RouterLink to="/profile">
                                            <img :src="menuProfileIcon" />
                                            <span class="rlms-fs-sm">Profile</span>
                                        </RouterLink>
                                    </li>
                                    <li>
                                        <RouterLink to="/account-setting">
                                            <img :src="menuSettingIcon" />
                                            <span class="rlms-fs-sm">Account Setting</span>
                                        </RouterLink>
                                    </li>
                                    <li>
                                        <a href="https://datamakesthedifference.com/contact-us/">
                                            <img :src="supportIcon" />
                                            <span class="rlms-fs-sm">Support</span>
                                        </a>
                                    </li>
                                    <li>
                                        <RouterLink to="/change-password">
                                            <img :src="menuSettingIcon" />
                                            <span class="rlms-fs-sm">Change Password</span>
                                        </RouterLink>
                                    </li>
                                    <li class="rlms-profile-logout-box">
                                        <a href="javascriptLvoid(0);" @click.prevent="logout">
                                            <img :src="logoutIcon">
                                            <span class="rlms-fs-sm">Logout</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="header__btn__box" v-if="!authStore.user">
                        <span class="signin__link">
                            <RouterLink to="/login">Sign In</RouterLink>
                        </span>
                        <div class="register__btn">
                            <RouterLink to="/register">Register</RouterLink>
                        </div>
                    </div>

                    <!-- Mobile Menu Icon -->
                    <div class="mobile__menu" @click="toggleMenu">
                        <div id="nav-icon3" :class="{ open: mobileOpen }">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </header>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import { useRoute, RouterLink, useRouter } from 'vue-router'
import tippy from 'tippy.js';
import { useAuthStore } from '@/stores/auth';
const authStore = useAuthStore();
import logo from '@/assets/logo.png'
import navBarSvg from '@/assets/images/navbar_blade_7b30c419.svg'
import menuProfileIcon from '@/assets/images/menu-profile-icon.png'
import menuSettingIcon from '@/assets/images/menu-setting-icon.png'
import supportIcon from '@/assets/images/support-icon.png'
import logoutIcon from '@/assets/images/menu-logout-icon.svg'
import { showToast } from '@/utils/swal';

const route = useRoute()
const router = useRouter()
const mobileOpen = ref(false)
const trigger = ref(null);
const tooltipContent = ref(null);
const learnerRouteNames = ['LearnerDashboard', 'LearnerVoiceBank', 'LearnerVoiceBankTestItem', 'LearnerAssessment', 'LearnerWorkpacketDetail', 'LearnerWorkpacket'];

const toggleMenu = () => {
    mobileOpen.value = !mobileOpen.value;

    if (mobileOpen.value) {
        document.body.classList.add('menu-open');
        document.documentElement.style.overflow = 'hidden';
    } else {
        document.body.classList.remove('menu-open');
        document.documentElement.style.overflow = '';
    }
};


const isActive = (path) => {
    return route.path === path
}

onMounted(async () => {
    await nextTick();
    if (!trigger.value || !tooltipContent.value) return;

    const tooltipInstance = tippy(trigger.value, {
        content: tooltipContent.value,
        trigger: 'click',
        placement: 'bottom',
        interactive: true,
        allowHTML: true,
        theme: 'light',
        onShow() {
            const wrapper = document.querySelector('.rlms-tooltip-wrapper');
            if (wrapper) {
                wrapper.classList.add('rlms-tooltip-active');
            }
        },
        onHide() {
            const wrapper = document.querySelector('.rlms-tooltip-wrapper');
            if (wrapper) {
                wrapper.classList.remove('rlms-tooltip-active');
            }
        }
    });

    // Hide or destroy tooltip on route change
    router.beforeEach((to, from, next) => {
        tooltipInstance.hide(500);
        if (mobileOpen.value) {
            toggleMenu();
        }
        next();
    });
});

const logout = async () => {
    await authStore.logout();

    showToast({
        icon: 'success',
        title: 'Goodbye! ',
        text: "You have been logged out successfully.",
    });

    router.push('/');
}
</script>
